import { useMutation } from '@tanstack/react-query';
import { LoginRequest } from '@/types/request/LoginRequest';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import { queryClient } from '@/main.tsx';
import { User } from '@/models/User';

const useLogin = () => {
  const mutationFn = async (request: LoginRequest) => {
    return login(request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['user'] });
    },
  });
};

export default useLogin;

async function login(request: LoginRequest): Promise<User> {
  try {
    const response = await BackendClient.post<BackendSuccessResponse<User>>('/api/auth/login', request);

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while logging in.');
  }
}
